<!-- AdminSettings.vue -->
 
<template>
  <v-container>
    <h1>Настройки сокращений</h1>
    <v-data-table
      :headers="headers"
      :items="abbreviations"
      :items-per-page="10"
    >
      <!-- Старый синтаксис слотов: slot="item.actions" + slot-scope="{ item }" -->
      <template slot="item.actions" slot-scope="{ item }">
        <v-btn color="blue" @click="openEdit(item)">Изменить</v-btn>
        <v-btn color="red" @click="deleteAbbr(item.id)">Удалить</v-btn>
      </template>
    </v-data-table>

    <!-- Кнопка добавления -->
    <v-btn color="primary" class="mt-3" @click="openAdd">Добавить сокращение</v-btn>

    <!-- Диалог добавления/редактирования -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editingItem.id ? 'Изменить' : 'Добавить' }} сокращение
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editingItem.abbr"
            label="Сокращение"
          ></v-text-field>
          <v-text-field
            v-model="editingItem.full_text"
            label="Расшифровка"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="green" @click="saveAbbr">Сохранить</v-btn>
          <v-btn color="grey" @click="dialog = false">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminSettings', // Многословное имя вместо "Settings"
  data() {
    return {
      abbreviations: [],
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Сокращение', value: 'abbr' },
        { text: 'Расшифровка', value: 'full_text' },
        { text: 'Действия', value: 'actions', sortable: false },
      ],
      dialog: false,
      editingItem: {},
    };
  },
  mounted() {
    this.loadAbbreviations();
  },
  methods: {
    async loadAbbreviations() {
      try {
        const res = await axios.get('https://geonode.qpark.io/api/abbreviations');
        this.abbreviations = res.data;
      } catch (err) {
        console.error('Ошибка загрузки словаря:', err);
      }
    },
    openAdd() {
      this.editingItem = {};
      this.dialog = true;
    },
    openEdit(item) {
      this.editingItem = { ...item }; // копия
      this.dialog = true;
    },
    async saveAbbr() {
      try {
        if (this.editingItem.id) {
          // PUT
          await axios.put(`https://geonode.qpark.io/api/abbreviations/${this.editingItem.id}`, {
            abbr: this.editingItem.abbr,
            full_text: this.editingItem.full_text
          });
        } else {
          // POST
          await axios.post('https://geonode.qpark.io/api/abbreviations', {
            abbr: this.editingItem.abbr,
            full_text: this.editingItem.full_text
          });
        }
        this.dialog = false;
        this.loadAbbreviations();
      } catch (err) {
        console.error('Ошибка сохранения:', err);
        alert('Ошибка сохранения сокращения');
      }
    },
    async deleteAbbr(id) {
      if (!confirm('Удалить сокращение?')) return;
      try {
        await axios.delete(`https://geonode.qpark.io/api/abbreviations/${id}`);
        this.loadAbbreviations();
      } catch (err) {
        console.error('Ошибка удаления:', err);
        alert('Ошибка удаления сокращения');
      }
    },
  },
};
</script>

<style scoped>
/* при необходимости стили */
</style>
